// Module
var code = "<title>Customily - Forgot password</title> <div ng-cloak class=\"h100\"> <vue-component name=\"ForgotPassword\" class=\"h100\"/> </div> ";
// Exports
module.exports = code;